import { render } from "./HiIconItem.vue?vue&type=template&id=24399f5a&scoped=true"
import script from "./HiIconItem.vue?vue&type=script&lang=js"
export * from "./HiIconItem.vue?vue&type=script&lang=js"

import "./HiIconItem.vue?vue&type=style&index=0&id=24399f5a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24399f5a"]])

export default __exports__